import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Rental agreements stats DTO
 */
@CaslSubject(AppSubjectEnum.RENTAL_AGREEMENT)
export class RentalAgreementsStatsDto extends BaseStatsDto {
	pending!: number;
	inProgress!: number;
	completed!: number;
	cancelled!: number;
}
